import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_KEY } from "./constants";
var localeEn = /*#__PURE__*/_defineProperty({}, PAGE_KEY, {
  FILTER_MOST_CONSULTED: 'Most consulted',
  FILTER_GENERAL: 'General',
  FILTER_ELEARNING: 'E-learning',
  FILTER_CLIMATE_RECOGNITION: 'Climate and recognition',
  FILTER_PERFORMANCE: 'Performance',
  LABEL_CATEGORIES: 'Categories',
  LABEL_CATEGORIES_TEXTAREA: 'Categories',
  LABEL_TOOLTIP_FILTER_BUTTON: 'Suggested categories',
  LABEL_FILTER_TITLE: 'Select an option to get suggestions for related queries'
});
export default localeEn;